import service from './index'

export const apiPostMessage = (info, config = {}) => service.post('/ws/chat', info, config);

export const apiConfig = info => service.get('/ucs/config', info);
//获取律师信息
export const apiLawerInfo = info => service.get('/chat/pc/firm', info);
//获取数据
export const apiGetPage = info => service.get('/ucs/data/page', { params: info });
//获取详情数据
export const apiGetDetail = info => service.get('/ucs/data/detail', { params: info });
export const apiGetCustom = info => service.get('/ucs/config', { params: info });
//修改详情数据
export const apiEditInfo = (info, config = {}) => service.put('/ucs/data/edit', info, config);
//账号登录
export const apiAccountLogin = (info, config = {}) => service.post('/login/login-by-password', info, config);
//请求验证码code
export const apiGetCaptchaWord = info => service.get('/open/get-word-captcha', { params: info });
//发送邮箱验证码
export const apiPostEmailCaptcha= (info, config = {}) => service.post('/open/send-email-captcha', info, config);
//邮箱验证码登录
export const apiLoginByEmailCaptcha = (info, config = {}) => service.post('/login/login-by-email-captcha', info, config);
//发送手机验证码
export const apiPostPhoneCaptcha= (info, config = {}) => service.post('/open/send-sms-captcha', info, config);
// 发送验证码2
export const apiPostPhoneCaptcha2= info => service.get('/open/send-sms-captcha', info);
//手机验证码登录
export const apiLoginByPhoneCaptcha = (info, config = {}) => service.post('/login/login-by-sms-captcha', info, config);
//获取个人信息
export const apiGetMineInfo = info => service.get('/user/current', { params: info });
//更新个人信息
export const apiEditMineInfo = info => service.post('/user/edit', info);
//添加
export const apiAddInfo = info => service.post('/ucs/data/add', info);
//删除
export const apiDeleteInfo = info => service.delete('/ucs/data/delete', { params: info });
//获取应用数据
export const apiGetApplicationDetail = (id) => service.get(`/ucs/application-config/${id}`);
//编辑
export const apiCheckEmail = info => service.post('/user/check-by-email-captcha', info);
export const apiCheckPhone = info => service.post('/user/check-by-sms-captcha', info);
export const apiResetPhone = info => service.post('/user/reset-phone', info);
export const apiResetEmail = info => service.post('/user/reset-email', info);
export const apiResetPassword = info => service.post('/user/reset-password', info);
export const apiCheckAccount = info => service.post('/login/check-account', info);
